import React from 'react';
import * as echarts from 'echarts';
import EchartsReactCore from './core';

const EchartsReact = (props) => {
  // Pass the echarts library to EchartsReactCore
  return <EchartsReactCore {...props} echarts={echarts} />;
};

export default EchartsReact;

